export enum SlackProvider {
	SLACK_WEBHOOK = 'SLACK_WEBHOOK',
	SLACK_BOT = 'SLACK_BOT',
}
